<template>
	<div class="listagem-de-orgaos-por-item">
		<template-listagem-vazia :textos="textosTemplateListagemVazia" v-if="itens.length < 1">
		</template-listagem-vazia>
		<virtual-v-data-table :headers="headers" :items="itens" v-else>
			<template #item.orgaoSigla="{ item }">
				<div class="d-flex arp_icon_and_text">
					<icone-tooltip
						v-if="item.externo"
						icone="mdi-file-import-outline"
						cor="primary"
						texto="Adesão Pública"
						tamanho="15px"
					></icone-tooltip>
					<texto-tooltip
						:texto="item.orgaoSigla ? item.orgaoSigla : '--'"
						:tamanho-maximo="20"
					></texto-tooltip>
				</div>
			</template>
			<template #item.quantidadeSolicitada="{ item }">
				<v-tooltip top>
					<template #activator="{ on, attrs }">
						<span v-bind="attrs" v-on="on">{{
							item.saldoOrgaoOriginal | rpCurrencyFilter('', numeroCasasDecimaisQtde)
						}}</span>
					</template>
					<span>{{ item.saldoOrgaoOriginal | rpCurrencyFilter('', numeroCasasDecimaisQtde) }}</span>
				</v-tooltip>
			</template>
			<template #item.quantidadeUtilizada="{ item }">
				<v-tooltip top>
					<template #activator="{ on, attrs }">
						<span v-bind="attrs" v-on="on">{{
							item.quantidadeSolicitada | rpCurrencyFilter('', numeroCasasDecimaisQtde)
						}}</span>
					</template>
					<span>{{ item.quantidadeSolicitada | rpCurrencyFilter('', numeroCasasDecimaisQtde) }}</span>
				</v-tooltip>
			</template>
			<template #item.quantidadeTransferido="{ item }">
				<v-tooltip top>
					<template #activator="{ on, attrs }">
						<span v-bind="attrs" v-on="on">{{
							item.quantidadeTransferido | rpCurrencyFilter('', numeroCasasDecimaisQtde)
						}}</span>
					</template>
					<span>{{ item.quantidadeTransferido | rpCurrencyFilter('', numeroCasasDecimaisQtde) }}</span>
				</v-tooltip>
			</template>
			<template #item.quantidadeRecebidaTransferencia="{ item }">
				<v-tooltip top>
					<template #activator="{ on, attrs }">
						<span v-bind="attrs" v-on="on">{{
							item.quantidadeRecebidaTransferencia | rpCurrencyFilter('', numeroCasasDecimaisQtde)
						}}</span>
					</template>
					<span>{{
						item.quantidadeRecebidaTransferencia | rpCurrencyFilter('', numeroCasasDecimaisQtde)
					}}</span>
				</v-tooltip>
			</template>
			<template #item.saldoOrgao="{ item }">
				<v-tooltip top>
					<template #activator="{ on, attrs }">
						<span v-bind="attrs" v-on="on">{{
							item.saldoOrgao | rpCurrencyFilter('', numeroCasasDecimaisQtde)
						}}</span>
					</template>
					<span>{{ item.saldoOrgao | rpCurrencyFilter('', numeroCasasDecimaisQtde) }}</span>
				</v-tooltip>
			</template>
			<template #item.acoes="{ item }">
				<a @click="abrirDetalhes(item)">Detalhes</a>
			</template>
		</virtual-v-data-table>
	</div>
</template>
<script>
import { actionTypes } from '@/core/constants'
import VirtualVDataTable from '@/views/components/VirtualVDataTable.vue'
import TemplateListagemVazia from '@/views/components/TemplateListagemVazia.vue'

export default {
	name: 'listagem-de-orgaos-por-item',
	components: { TemplateListagemVazia, VirtualVDataTable },
	props: {
		infoItemAta: {
			type: Object,
			required: true,
		},
	},
	emits: ['abrir-detalhes'],

	data() {
		return {
			itens: [],
			headers: [
				{ name: 'Órgão', value: 'orgaoSigla' },
				{ name: 'Solicitado', value: 'quantidadeSolicitada', align: 'left' },
				{ name: 'Utilizado', value: 'quantidadeUtilizada', align: 'left' },
				{ name: 'Transferido', value: 'quantidadeTransferido', align: 'left' },
				{ name: 'Recebido Transferência', value: 'quantidadeRecebidaTransferencia', align: 'left' },
				{ name: 'Saldo Órgão', value: 'saldoOrgao', align: 'left' },
				{ name: 'Ações', value: 'acoes' },
			],
			textosTemplateListagemVazia: {
				titulo: 'Sem órgãos para detalhar o item',
				mensagem: 'Não existem órgãos com previsão de consumo para o item selecionado!',
			},
		}
	},
	computed: {
		numeroCasasDecimaisQtde: {
			get() {
				return this.$store.state.ata.informacoesAta.numeroCasasDecimaisQtde
			},
		},
	},
	watch: {
		async infoItemAta() {
			await this.loadData()
		},
	},
	async created() {
		await this.loadData()
	},
	methods: {
		async loadData() {
			try {
				const { itens } = await this.$store.dispatch(
					actionTypes.ATA.ACOMPANHAMENTO.BUSCAR_LISTAGEM_SALDO_ORGAO_POR_ITEM,
					{
						paginacao: { page: 1, rowsPerPage: 999999999 },
						idItemAta: this.infoItemAta.id,
						idAta: this.$route.params.id,
					},
				)
				this.itens = itens
			} catch (Err) {
				throw new Error(Err)
			}
		},
		abrirDetalhes(item) {
			this.$emit('abrir-detalhes', { itemAtaDetalhe: item, pedidoDetalhe: this.infoItemAta })
		},
	},
}
</script>
